<div class="page dash">
  <div class="dashboard-header">
    <div>
      <h4>{{ storeName
        ? ('store.dashboard.greetingNamed' | translate: { name: storeName })
        : ('store.dashboard.greeting' | translate) }}</h4>
      <div class="date">{{ currentDate }}</div>
    </div>

    <div class="btns-container">
      <button type="button" (click)="scanRedeem()">
        <img src="assets/images/scan-btn.png" alt="">
        {{ 'store.dashboard.redeem' | translate }}
      </button>
      <button
        type="button"
        *ngIf="(featureFlagService.isFeatureEnabled$('store_vouchers') | async)"
        (click)="onCreateVoucher()"
      >
        <img src="assets/images/add-btn.png" alt="">
        {{ 'store.dashboard.createVoucher' | translate }}
      </button>
      <button type="button" (click)="goToTransactions()">
        {{ 'store.dashboard.viewTransactions' | translate }}
      </button>
    </div>
  </div>

  <div class="dash__payment-code">
    <div class="dash__payment-code-text">
      <div class="dash__payment-code-title">{{ 'store.dashboard.paymentCode.title' | translate }}</div>
      <div class="dash__payment-code-value" *ngIf="data?.paymentCode; else noCode">{{ data.paymentCode }}</div>
      <ng-template #noCode>
        <div class="dash__payment-code-empty">{{ 'store.dashboard.paymentCode.none' | translate }}</div>
      </ng-template>
      <div class="dash__payment-code-hint">{{ 'store.dashboard.paymentCode.hint' | translate }}</div>
    </div>
    <button
      type="button"
      class="dash__copy-btn"
      *ngIf="data?.paymentCode"
      (click)="copyPaymentCode()"
    >
      <i class="fa" [class.fa-copy]="!codeCopied" [class.fa-check]="codeCopied" aria-hidden="true"></i>
      {{ (codeCopied ? 'store.dashboard.paymentCode.copied' : 'store.dashboard.paymentCode.copy') | translate }}
    </button>
  </div>

  <div class="cards-main-container">
    <div class="card-container">
      <div class="card card--primary">
        <div class="title">{{ 'store.dashboard.cards.balance' | translate }}</div>
        <div  class="value"><span class="ltr-text">{{ balance | currency: balanceCurrency : 'code' }}</span></div>
      </div>

      <div class="card">
        <div class="title">{{ 'store.dashboard.cards.redemptionPoints' | translate }}</div>
        <div class="value">{{ data?.redemptionPointsCount || 0 }}</div>
        <div class="card-footer">
          <button type="button" class="card-link" (click)="goToRedemptionPoints()">
            {{ 'store.dashboard.viewAll' | translate }}
            <img class="card-link__icon" src="assets/images/right-model.svg" alt="">
          </button>
        </div>
      </div>

      <div class="card" *ngIf="(featureFlagService.isFeatureEnabled$('store_dashboard_vouchers') | async)">
        <div class="title">{{ 'store.dashboard.cards.vouchers' | translate }}</div>
        <div class="value">{{ data?.vouchers || 0 }}</div>
      </div>

      <div class="card" *ngIf="(featureFlagService.isFeatureEnabled$('store_dashboard_available_codes') | async)">
        <div class="title">{{ 'store.dashboard.cards.availableCodes' | translate }}</div>
        <div class="value">{{ data?.availableCodes || 0 }}</div>
      </div>

      <div class="card" *ngIf="data?.totalRedemptions">
        <div class="title">{{ 'store.dashboard.cards.totalRedemptions' | translate }}</div>
        <div  class="value"><span class="ltr-text">{{ data?.totalRedemptions?.balance | currency: data?.totalRedemptions?.currency?.code : 'code' }}</span></div>
        <div class="card-note">
          {{ 'store.dashboard.cards.redemptionsCount' | translate }}: {{ data?.totalRedemptionsCount || 0 }}
        </div>
      </div>

      <div class="card" *ngIf="data?.totalOrders">
        <div class="title">{{ 'store.dashboard.cards.orders' | translate }}</div>
        <div class="value">{{ data?.totalOrders || 0 }}</div>
        <div  class="card-note"><span class="ltr-text">{{ 'store.dashboard.cards.ordersValue' | translate }}:
          {{ data?.totalOrderBalance | currency: balanceCurrency : 'code' }}</span></div>
      </div>
    </div>
  </div>

  <div class="rp-list-section">
    <app-redemption-point-list [pagePath]="'dashboard'" [embedded]="true"></app-redemption-point-list>
  </div>
</div>
<app-redeem-modal
  #redeemModal
  [currencyCode]="balanceCurrency"
  (onRedeemAction)="onRedeem($event)"
  (onSuccess)="getData()">
</app-redeem-modal>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
